import { MMediaSelectorProps, MMediaSelectorMediaType } from '../MMediaSelector/MMediaSelector.types';

export interface MMediaBorderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> {
  aspectRatio?: MMediaBorderAspectRatio;
  mediaType?: MMediaSelectorMediaType;
  strokeWidth?: number;
  mMediaSelector?: MMediaSelectorProps;
  className?: string;
}

export enum MMediaBorderAspectRatio {
  TwoThree = '2:3',
  ThreeTwo = '3:2',
  OneOne = '1:1',
  SixteenNine = '16:9',
  FiveTwo = '5:2',
}
